// extracted by mini-css-extract-plugin
module.exports = {"fields":"Review_fields__2SXZS","column":"Review_column__10J5f","card":"Review_card__xK8B4","row":"Review_row__3mReg","columnMargin":"Review_columnMargin__28iO5"};